import * as React from 'react'
import Placeholder from '../Placeholder'
import Typography from '../Typography'
import * as Styled from './SplitContent.styles'

const SplitContent = ({
  alignMainContent = 'Center',
  alignImageToBottom = false,
  splitBackgroundColor = null,
  backgroundColor = null,
  backgroundImage = null,
  bottomPadding = null,
  children = null,
  hideImageOnMobile = false,
  borderRadius = null,
  aspectRatio = null,
  customPosition = null,
  image = null,
  imageWidth = null,
  mainContent = null,
  mobileAlignImageToBottom = false,
  mobileBackgroundImage = null,
  mobileImage = null,
  mobileTextColor = null,
  reverseForMobile = false,
  textColor = null,
  topPadding = null,
  width = null,
  ...props
}) => (
  // TODO: [LC-314] remove className from root element and use data-attribute
  <Styled.Section
    className={`leshen-split-content background-color-${
      backgroundColor || 'default'
    }`}
    splitBackgroundColor={splitBackgroundColor}
    hideImageOnMobile={hideImageOnMobile}
    alignMainContent={alignMainContent}
    alignImageToBottom={alignImageToBottom}
    mobileAlignImageToBottom={mobileAlignImageToBottom}
    imageWidth={imageWidth}
    mobileImage={mobileImage}
    reverseForMobile={reverseForMobile}
    backgroundColor={backgroundColor}
    textColor={textColor}
    mobileTextColor={mobileTextColor}
    topPadding={topPadding}
    bottomPadding={bottomPadding}
    width={width}
    {...props}
  >
    {backgroundImage && (
      <Styled.BackgroundImage mobileBackgroundImage={mobileBackgroundImage}>
        {backgroundImage}
      </Styled.BackgroundImage>
    )}
    {mobileBackgroundImage && (
      <Styled.MobileBackgroundImage>
        {mobileBackgroundImage}
      </Styled.MobileBackgroundImage>
    )}
    <Styled.SplitContentGrid
      className="split-content__grid"
      backgroundColor={backgroundColor}
      hasBackgroundImage={Boolean(backgroundImage)}
    >
      <Styled.Image
        borderRadius={borderRadius}
        aspectRatio={aspectRatio}
        customPosition={customPosition}
        className="split-content__image"
        mobileImage={mobileImage}
      >
        {image || mobileImage ? (
          <>
            <span className="mobile-image">{mobileImage}</span>
            <span className="desktop-image">{image}</span>
          </>
        ) : (
          <Placeholder type="error">
            <Typography variant="small">Notice</Typography>
            <Typography>
              The content entry of type &quot;SplitContent&quot; is missing the
              Image media asset.
            </Typography>
          </Placeholder>
        )}
      </Styled.Image>
      <div className="split-content__content">
        {mainContent}
        {children}
      </div>
    </Styled.SplitContentGrid>
  </Styled.Section>
)

export default SplitContent
